var map = {
	"./Accordion_comp.png": 566,
	"./Audio_comp.png": 567,
	"./Carousel_comp.png": 568,
	"./CeAssets.png": 191,
	"./Congratulate.png": 331,
	"./Course_Image_Flip.svg": 1118,
	"./Draggables_comp.png": 569,
	"./Flip_card.svg": 1119,
	"./Group_sidebar_logo.png": 335,
	"./ImageSelect_comp.png": 570,
	"./Image_text.png": 571,
	"./Imagemapping_comp.png": 572,
	"./Marketing_Data.png": 573,
	"./Ordered_comp.png": 574,
	"./Photographs.png": 575,
	"./Price_Quotation.png": 576,
	"./Quizzes_comp_.png": 577,
	"./Quotes.svg": 1120,
	"./Scenario.svg": 1121,
	"./Schematics.png": 578,
	"./Software_Source_Code.png": 579,
	"./Tab_comp.png": 580,
	"./Test_Data.png": 581,
	"./Textbooks.png": 582,
	"./Topicdesc_comp.png": 583,
	"./Unordered_comp.png": 584,
	"./Video_comp.png": 585,
	"./alert_warning.png": 586,
	"./arrow_next.png": 431,
	"./arrow_prev.png": 432,
	"./assesment_wizard.png": 587,
	"./back-ten_1.png": 433,
	"./bg.jpg": 1122,
	"./bg_1.JPG": 1123,
	"./bg_1_.JPG": 1124,
	"./bg_2.jpeg": 1125,
	"./car_image.png": 588,
	"./cc_text.svg": 1126,
	"./ce_author.png": 256,
	"./ce_logo_skill_comp.png": 134,
	"./ce_notes.png": 589,
	"./ce_notes_bribery.png": 590,
	"./certificate.png": 591,
	"./certificate_print.png": 434,
	"./content_cancel.png": 336,
	"./content_plus.png": 337,
	"./cuepoints_notes.png": 430,
	"./cuepoints_window.png": 429,
	"./default_icon.png": 592,
	"./drag_and_match.png": 593,
	"./ecx_cat2_icon_Award_300_rgb.png": 594,
	"./expand_tree.png": 435,
	"./flags/ar_BH.svg": 1127,
	"./flags/ar_MA.svg": 1128,
	"./flags/cs_CZ.svg": 1129,
	"./flags/da_DK.svg": 1130,
	"./flags/de_DE.svg": 1131,
	"./flags/en_US.svg": 1132,
	"./flags/es_ES.svg": 1133,
	"./flags/es_LA.svg": 1134,
	"./flags/fi_FI.svg": 1135,
	"./flags/fr_CA.svg": 1136,
	"./flags/fr_FR.svg": 1137,
	"./flags/he_HE.svg": 1138,
	"./flags/it_IT.svg": 1139,
	"./flags/ja_JP.svg": 1140,
	"./flags/kn_IN.svg": 1141,
	"./flags/ko_KR.svg": 1142,
	"./flags/ms_MY.svg": 1143,
	"./flags/nl_NL.svg": 1144,
	"./flags/pl_PL.svg": 1145,
	"./flags/pt_BR.svg": 1146,
	"./flags/ru_RU.svg": 1147,
	"./flags/sv_SE.svg": 1148,
	"./flags/th_TH.svg": 1149,
	"./flags/tr_TR.svg": 1150,
	"./flags/vi_VN.svg": 1151,
	"./flags/zh_CN.svg": 1152,
	"./flags/zh_TW.svg": 1153,
	"./forward-ten_1.png": 436,
	"./full_screen.svg": 1154,
	"./laptop_icon.png": 595,
	"./legend_help.svg": 1155,
	"./logo.svg": 1156,
	"./man_standing.png": 596,
	"./mute.svg": 1157,
	"./noun_pagination_99092.png": 597,
	"./pause.svg": 1158,
	"./pdf.png": 598,
	"./phone_icon.png": 599,
	"./play.svg": 1159,
	"./powered_by.png": 338,
	"./ppt.png": 600,
	"./profile_icon.png": 231,
	"./profile_logo.jpg": 1160,
	"./reorder-icon.png": 601,
	"./replay.svg": 1161,
	"./schar_certificate.png": 602,
	"./search.png": 603,
	"./suppliment_yellow.svg": 1162,
	"./tablet_icon.png": 604,
	"./teck_uk.png": 267,
	"./testimonal_text.png": 605,
	"./topic_header.png": 606,
	"./volume.svg": 1163,
	"./widget_yellow.svg": 1164,
	"./window_tab.png": 607,
	"./word.png": 608,
	"./xlsx.png": 609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 246;